import axios from './AxiosService';

export default class EstatusSolicitudService {
  async get() {
    return await axios.get('/estatus-solicitud').then(result => result.data);
  }
}